import { EMessageType, MessageType } from '@web/dtos';

export class Logging {
  public sendToBackend(type: string, message: string): void {
    // to overwrite
  }

  public withDate(type: MessageType, stage: string, template: string): string {
    let message = `[${new Date().toLocaleString('de')}] ${stage} - ${template}`;
    switch (type) {
      case EMessageType.ERROR:
        message = '\x1b[31m' + '❌ ' + message;
        break;
      case EMessageType.SUCCESS:
        message = '\x1b[32m' + '✅ ' + message;
        break;
      case EMessageType.INFO:
        message = '\x1b[34m' + '💡' + message;
        break;
      case EMessageType.WARNING:
        message = '\x1b[33m' + '⚠️ ' + message;
        break;
    }
    return message;
  }

  public maskFields<T extends Record<string, any>>(
    obj: T,
    fields: string[]
  ): T {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        fields.includes(key) ? '****' : value,
      ])
    ) as T;
  }

  public maskFieldsDeep<T>(value: T, fields: readonly string[]): T {
    if (Array.isArray(value)) {
      return value.map(v => this.maskFieldsDeep(v, fields)) as T;
    }

    if (value !== null && typeof value === 'object') {
      return Object.fromEntries(
        Object.entries(value).map(([key, val]) => [
          key,
          fields.includes(key) ? '****' : this.maskFieldsDeep(val, fields),
        ])
      ) as T;
    }

    return value;
  }

  success(template: string, ...optionalParams: unknown[]): void {
    if (template === '') return;
    this.sendToBackend(EMessageType.INFO, template);
    console.log(
      this.withDate(EMessageType.SUCCESS, 'Success', template),
      ...optionalParams
    );
  }

  info(template: string, ...optionalParams: unknown[]): void {
    if (template === '') return;
    this.sendToBackend(EMessageType.INFO, template);
    console.info(
      this.withDate(EMessageType.INFO, 'Info', template),
      ...optionalParams
    );
  }

  warn(template: string, ...optionalParams: unknown[]): void {
    if (template === '') return;
    this.sendToBackend(EMessageType.WARNING, template);
    console.warn(
      this.withDate(EMessageType.WARNING, 'Warn', template),
      ...optionalParams
    );
  }

  error(template: string, ...optionalParams: unknown[]): void {
    if (template === '') return;
    this.sendToBackend(EMessageType.ERROR, template);
    console.error(
      this.withDate(EMessageType.ERROR, 'Error', template),
      ...optionalParams
    );
  }
}
